<template>
  <div id="customer_login">
    <form @submit.prevent="formSubmit" class="">
      <div class="bg-white mb-2">
        <div class="form-shadow">
          <div class="row">
            <div class="col-lg-12" id="sells-s">
              <div class="form-group">
                <InputField class="col-md-12" type="text" :is-required="true" :label="$t('Phone Number')" placeholder="" v-model="phone" :error-message="errors['phone']" :error-messages="errorMessages['phone']" maxlength="10"></InputField>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button :disabled="isDisable" type="submit" class="btn btn-primary fw-600 rounded-0 reg-btn">
          <span v-if="!isDisable">GET OTP</span>
          <span v-else>
            <i class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></i>
            Sending...
          </span>
        </button>
      </div>
      <div class="already-text">
        <p>Back to?<a :href="loginRoute"><span> Login</span></a> </p>
      </div>
    </form>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import InputField from '@/vue/components/form-elements/InputField.vue'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import axios from 'axios'
import {otpVerify} from '../constant/auth.js'

const errorMessages = ref({});
const defaultData = () => {
  errorMessages.value = {}
  return {
    phone: '',
  }
}
const { loginRoute } = defineProps(['loginRoute']);
const isDisable = ref(false)
const setFormData = (data) => {
  resetForm({
    values: {
      phone: data.phone,
    }
  })
}
const validationSchema = yup.object({
  phone: yup.string().required('Phone is a required field'),
})

const { handleSubmit, errors, resetForm } = useForm({
  validationSchema
})
const { value: phone } = useField('phone')
const formSubmit = handleSubmit(async () => {
  isDisable.value = true; 
  try {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    const sendOtp = await axios.post(`send-otp`, {
      phone: phone.value
    });
    const otpVerifications = otpVerify();
    console.log(sendOtp)
    if (sendOtp.status === 200) {
      window.successSnackbar(sendOtp.data.message);
      let mobile_number = sendOtp.data.phone;
      let redirectUrl = sendOtp.data.appUrl + '/' + otpVerifications.path + '?mobile=' + mobile_number;
      window.location.href = redirectUrl;
    } else {
      window.errorSnackbar(sendOtp.data.message);
    }
  } catch (validationErrors) {
    errorMessages.value = validationErrors.errors;
    console.log(errorMessages.value);
  } finally {
    isDisable.value = false; 
  }
});
</script>
